// extracted by mini-css-extract-plugin
export default {"Main":"SlideShowElement_Main__yia-t"};